import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import {
  getDefaultServiceIntakeQuestions,
  getServiceIntakeQuestions,
} from '../../services/business';

export const serviceIntakeQuestionsKey = (
  businessId: string | undefined,
  serviceId: number | null,
) => ['serviceIntakeQuestions', businessId, serviceId];

function useGetServiceIntakeQuestions(serviceId: number | null) {
  const { user } = useUser();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: serviceIntakeQuestionsKey(user?.business?.id, serviceId),
    queryFn: async () => {
      if (!user?.business?.id) return null;
      if (serviceId === null) {
        return getDefaultServiceIntakeQuestions(user.business.id);
      }
      return getServiceIntakeQuestions(user.business.id, serviceId);
    },
    enabled: !!user?.business?.id,
  });

  return {
    questions: data ?? [],
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetServiceIntakeQuestions;
